import 'babel-polyfill'
import 'whatwg-fetch'

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import { IntlProvider } from 'react-intl'
import LocalizationData from './data/LocalizationData'
import QueryString from 'query-string'

import {
  osName
} from "react-device-detect";

import App from './components/App'

import { setTheme, setOs, setPopinfoId, setAppVersion } from './actions'

import configureStore from './store'
const store = configureStore()

import './stylesheets/main.scss'

const localeMatch = window.navigator.userAgent.match(/Language:(ja|en|ko|zh-cn)/)
const locale = localeMatch ? localeMatch[1] : 'ja'
const themeMatch = window.navigator.userAgent.match(/ThemeName:(default|sounyan|train)/)
const themeName = themeMatch ? themeMatch[1] : 'default'
store.dispatch(setTheme(themeName))
store.dispatch(setOs(osName))

const appVersionMatch = window.navigator.userAgent.match(/SotetsuApp[\/:](\d+\.\d+\.\d+)/)
const appVersion = appVersionMatch ? appVersionMatch[1] : null
store.dispatch(setAppVersion(appVersion))
const query = QueryString.parse(location.search)
const popinfoId = query['popinfo_id']
store.dispatch(setPopinfoId(popinfoId))

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <IntlProvider locale={locale} messages={LocalizationData.getMessagesData(locale)}>
        <Router>
          <App />
        </Router>
      </IntlProvider>
    </Provider>
  </React.StrictMode>
);
